import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    helpNotFoundRoot: {
      padding: '40px 0px',
      opacity: '.6',
      '& img': { display: 'none' },
      '& div': { justifyContent: 'start' }
    }
  });
